import React from 'react';

import { FormattedMessage, injectIntl } from 'react-intl';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomSelect from './customSelect';

class MarketplacePredictedOrderItems extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      predictedOrderItems: props.formData,
    };

    this.add = this.add.bind(this);
    this.remove = this.remove.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onItemIdChange = this.onItemIdChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      predictedOrderItems: nextProps.formData,
    });
  }

  onChange(index, fieldName) {
    return (event) => {
      const newPredictedOrderItems = this.state.predictedOrderItems;
      newPredictedOrderItems[index][fieldName] = event.target.value;

      this.setState(
        {
          predictedOrderItems: newPredictedOrderItems,
        },
        () => this.props.onChange(this.state.predictedOrderItems)
      );
    };
  }

  add() {
    this.setState(
      {
        predictedOrderItems: [
          ...this.state.predictedOrderItems,
          {
            itemId: null,
            predictedQuantity: '1',
          },
        ],
      },
      () => this.props.onChange(this.state.predictedOrderItems)
    );
  }

  remove(index) {
    const newPredictedOrderItems = this.state.predictedOrderItems;
    newPredictedOrderItems.splice(index, 1);
    this.setState(
      {
        predictedOrderItems: newPredictedOrderItems,
      },
      () => this.props.onChange(this.state.predictedOrderItems)
    );
  }

  onItemIdChange(index) {
    return (newValue) => {
      const newValues = [...this.state.predictedOrderItems];
      newValues[index]['itemId'] = newValue;

      this.setState(
        {
          predictedOrderItems: newValues,
        },
        () => this.props.onChange(this.state.predictedOrderItems)
      );
    };
  }

  render() {
    const itemOptions = this.props.schema.items.map((item) => {
      return {
        label: item.name,
        value: item.id,
      };
    });

    return (
      <div>
        <legend>
          <FormattedMessage id={'delivery.day.marketplace.form.predicted.order.items.legend'} />
        </legend>

        {this.state.predictedOrderItems.map((predictedOrderItem, index) => {
          return (
            <div key={index} className="delivery-day-marketplace-form__predicted-order-items">
              <div className="row">
                <div className="col-12 col-sm-6">
                  <div className="form-group">
                    <CustomSelect
                      schema={{
                        title: this.props.intl.formatMessage({
                          id: 'delivery.day.marketplace.form.field.predicted.order.items.field.item.id.label',
                        }),
                        options: itemOptions,
                      }}
                      onChange={this.onItemIdChange(index)}
                      formData={predictedOrderItem.itemId}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage
                        id={'delivery.day.marketplace.form.field.predicted.order.items.field.predicted.quantity.label'}
                      />
                    </label>
                    <div className="m-b-1">
                      <input
                        className="form-control"
                        placeholder=""
                        type="text"
                        value={predictedOrderItem.predictedQuantity}
                        onChange={this.onChange(index, 'predictedQuantity')}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-right">
                <button onClick={() => this.remove(index)} className="btn btn-default btn-small">
                  <FormattedMessage id={'delivery.day.marketplace.form.field.predicted.order.items.remove'} />
                </button>
              </div>
            </div>
          );
        })}

        <div className="marketplace-form__delivery-preferences-add m-b-1" onClick={this.add}>
          <small>
            <FontAwesomeIcon icon={faPlusCircle} />{' '}
            <FormattedMessage id={'delivery.day.marketplace.form.field.predicted.order.items.add'} />
          </small>
        </div>
      </div>
    );
  }
}

export default injectIntl(MarketplacePredictedOrderItems);
